// @ts-nocheck
import { useEffect } from "react";

interface Props {
  disabled?: boolean;
}

export default function useCRM({ disabled }: Props = {}) {
  useEffect(() => {
    if (disabled) {
      return;
    }

    (function (q, g, r, a, p, h, js) {
      if (q.qg) return;
      js = q.qg = function () {
        js.callmethod
          ? js.callmethod.call(js, arguments)
          : js.queue.push(arguments);
      };
      js.queue = [];
      p = g.createElement(r);
      p.async = !0;
      p.src = a;
      h = g.getElementsByTagName(r)[0];
      h.parentNode.insertBefore(p, h);
    })(
      window,
      document,
      "script",
      "https://cdn.qgr.ph/qgraph.de05974025586f60ff33.js",
    );
  }, [disabled]);
}
